import { motion } from 'framer-motion'
import { Check } from 'lucide-react'
import { JoinCtaButton } from './JoinCtaButton'
import { MoneyBackGuarantee } from './MoneyBackGuarantee'
import { fadeUp } from '../lib/motion'
import { useT } from '../i18n/t'

const bulletKeys = [
  'sales.conversion.bullet1',
  'sales.conversion.bullet2',
  'sales.conversion.bullet3',
] as const

type SalesConversionCardProps = {
  className?: string
}

export function SalesConversionCard({ className = '' }: SalesConversionCardProps) {
  const { t } = useT()

  return (
    <motion.aside
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.35 }}
      variants={fadeUp}
      className={
        'rounded-lg border border-ink/10 bg-gradient-to-br from-brand/15 via-paper to-paper px-6 py-8 shadow-[0_20px_50px_rgba(35,35,35,0.08)] md:px-10 md:py-10 ' +
        className
      }
    >
      <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-ink/55">
        {t('sales.conversion.eyebrow')}
      </p>
      <h3 className="display mt-2 text-[24px] font-bold leading-[1.1] text-ink md:text-[32px]">
        {t('sales.conversion.title')}
      </h3>
      <p className="mt-3 max-w-[48ch] text-[15px] font-medium leading-relaxed text-ink/65 md:text-base">
        {t('sales.conversion.subtitle')}
      </p>

      <ul className="mt-6 space-y-3">
        {bulletKeys.map((key) => (
          <li
            key={key}
            className="flex items-start gap-3 text-[14px] font-semibold text-ink/80 md:text-[15px]"
          >
            <span className="mt-0.5 grid h-6 w-6 shrink-0 place-items-center rounded-full bg-brand/35 text-brand-ink">
              <Check className="h-3.5 w-3.5" aria-hidden />
            </span>
            {t(key)}
          </li>
        ))}
      </ul>

      <div className="mt-8">
        <JoinCtaButton size="xl" fullWidth>
          {t('sales.conversion.cta')}
        </JoinCtaButton>
      </div>

      <MoneyBackGuarantee className="mt-5" showTermsLink />
    </motion.aside>
  )
}
